import { Navigate, useParams } from "react-router-dom";
import { UserRole } from "../../utils/api/endpoints/user/credentials";
import RegisterForm from "../../components/authentication/RegisterForm";
import usePageTitle from "../../utils/hooks/usePageTitle";

/**
 * Depending on whether the URL contains a valid user type provides user
 * with the appropriate registration form to fill out. If the URL was
 * invalid - then user is sent back to the landing page
 */
const RegisterPage = () => {
  const { userType } = useParams();
  usePageTitle("Register");

  switch (userType) {
    case "researcher":
      return <RegisterForm userType={UserRole.RESEARCHER} />;
    case "business":
      return <RegisterForm userType={UserRole.BUSINESS} />;
    default:
      return <Navigate to="/invalid-role" />;
  }
};

export default RegisterPage;
